<div class="grid-container padding-y-4">
  <button class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="closeModal()">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
  <div class="grid-row grid-col-12">
    <legend class="usa-legend usa-legend--large">Shipment Tracking URL</legend>
    <p class="define-text-color-no-records">Note: will be added later.</p>
  </div>
  <form [formGroup]="shipmentTrackingUrlForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap-0">
        
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label for="Shipment Tracking Base URL" class="usa-label">Shipment Tracking Base URL
            <abbr title="required"
                  class="usa-hint usa-hint--optional">*</abbr>
          </label>
          <input type="text"
                 id="shipmentTrackingBaseUrl"
                 formControlName="shipmentTrackingBaseUrl"
                 class="usa-input maxw-full"
                 size='450'
                 maxlength='450'>
          <div
            *ngIf="this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').invalid && (this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').touched
                              || this.shipmentTrackingUrlForm.get('shipmentTrackingBaseUrl').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Shipment Tracking URL is required
            </small>
          </div>
        </div>
      </div>

      <div class="grid-row margin-top-4">
        <button type="button" class="usa-button"
                [disabled]="shipmentTrackingUrlForm.invalid || !shipmentTrackingUrlForm.dirty"
                (click)="saveContactInfo()">Save
        </button>
      </div>
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
